import { createFileRoute } from "@tanstack/react-router";

import { DataAccountPage } from "../../../features/settings/data-account-page";

export const Route = createFileRoute("/_app/settings/data")({ component: DataAccountPage });
